import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";

import { useSubscription } from "utils/useSubscription";

import styles from "../PlanCard/styles";
import PlansPrice from "../SharedComponents/Price";
import VATerms from "../SharedComponents/VATerms";
import { PlanAction, getCurrentPlanButton } from "../helpers";

const STATS = [
  { value: "10x", label: "More Efficient" },
  { value: "24/7", label: "Always Working" },
  { value: "100%", label: "Hands-Free" },
];

const MobilePlanCardAutopilot = () => {
  const { onPlanButtonClick } = useSubscription();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { plans, subscription, isAtEmailCreditCap } =
    useContext(SubscriptionContext);
  const action = getCurrentPlanButton(
    Plans.AUTOPILOT,
    subscription?.subscription?.planName || Plans.FREE,
    subscription,
  );
  const totalEmails = plans?.[Plans.AUTOPILOT]?.monthly_limit || 0;

  return (
    <Box sx={{ backgroundColor: "white", borderRadius: 3, mt: 1 }}>
      <Grid container justifyContent={"flex-end"} sx={{ pr: 1, pt: 1 }}>
        <Box
          sx={{
            backgroundColor: "#f59e0b",
            color: "white",
            borderRadius: 6,
            px: 2,
            py: 0.5,
            fontSize: 11,
            mb: 2,
            fontWeight: 600,
          }}
        >
          <Box component="span" className="fa-solid fa-crown" /> Hands-off
          pitching for busy creators
        </Box>
      </Grid>

      <Box sx={{ px: 3, pb: 3 }}>
        <Grid container justifyContent="space-between" alignItems="flex-end">
          <Typography variant="h4" sx={{ fontSize: 26 }}>
            Autopilot
          </Typography>
          <PlansPrice plan={Plans.AUTOPILOT} />
        </Grid>

        <Divider sx={{ my: 1, backgroundColor: "black" }} />

        {!isAtEmailCreditCap && (
          <Box sx={{ ...styles.rolloverInfoBox, mt: 2 }}>
            <Box sx={styles.rolloverInfoHeader}>
              <Box
                component="i"
                className="fa-solid fa-arrow-trend-up"
                sx={styles.rolloverInfoIcon}
              />
              <Typography sx={styles.rolloverInfoTitle}>
                Rollover Credits
              </Typography>
            </Box>
            <Typography sx={styles.rolloverInfoDesc}>
              Unused emails roll over monthly
            </Typography>
          </Box>
        )}

        <Typography>
          <strong>Includes everything in Pro, plus:</strong>
        </Typography>

        <Typography sx={{ fontSize: 14, lineHeight: 2 }}>
          🚀 Send {totalEmails} emails per month
          <br />
          🤖 Input your preferences for smart sourcing brands from sources like
          Instagram, TikTok, Google Maps & more
          <br />
          ✍️ Runs on autopilot so you set it up once and have weekly pitches
          sent automatically
          <br />
          🎯 Full control to review, approve, or pause any time
          <br />
          💸 Exclusive brand pay data
          <br />
        </Typography>

        <Grid
          container
          justifyContent="space-around"
          sx={{
            backgroundColor: "#f8fafc",
            borderRadius: 2,
            py: 1.5,
            mt: 2,
            mb: 1,
          }}
        >
          {STATS.map((stat, index) => (
            <Grid item key={index} sx={{ textAlign: "center" }}>
              <Typography
                sx={{ fontWeight: 800, fontSize: 18, color: "#4338ca" }}
              >
                {stat.value}
              </Typography>
              <Typography sx={{ fontSize: 11, color: "text.secondary" }}>
                {stat.label}
              </Typography>
            </Grid>
          ))}
        </Grid>

        {!currentOrg?.overridePlanName && (
          <Button
            disableElevation
            fullWidth
            variant={action === PlanAction.upgrade ? "contained" : "text"}
            sx={{
              fontSize: 16,
              mt: 2,
              py: 1,
              borderRadius: 2,
              backgroundColor:
                action === PlanAction.upgrade ? "#4338ca" : "#f4f8f6",
              color: action === PlanAction.upgrade ? "white" : undefined,
              "&:hover": {
                backgroundColor:
                  action === PlanAction.upgrade ? "#3730a3" : "#e8ece9",
              },
            }}
            onClick={() => onPlanButtonClick(Plans.AUTOPILOT, action)}
          >
            Upgrade to Autopilot
          </Button>
        )}

        <Grid container justifyContent={"center"} sx={{ mt: 1 }}>
          <VATerms plan={Plans.AUTOPILOT} />
        </Grid>
      </Box>
    </Box>
  );
};

export default MobilePlanCardAutopilot;
